<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <div class="row">
            <CCol sm="6" class="align-self-center">
              <strong>{{ $lang.recruitments.title }}</strong>
            </CCol>
            <CCol sm="6" class="align-self-center">
              <div class="text-sm-right mt-3 mt-sm-0">
                <CButton color="primary" v-on:click="createTableRow" style="margin-right: 10px;"
                         v-if="checkPermission('create-plan')">
                  {{ $lang.buttons.general.crud.create }}
                </CButton>
                <CButtonGroup class="file-export">
                  <CButton color="secondary" disabled>
                    {{ $lang.buttons.export.title }}
                  </CButton>
                  <CButton color="danger" v-c-tooltip="$lang.buttons.export.pdf"
                           v-on:click="exports(self,'pdf',module,'Recruitments')">
                    <i class="fas fa-file-pdf"></i>
                  </CButton>
                  <VueJsonToCsv class="btn btn-success" v-c-tooltip="$lang.buttons.export.excel" :json-data="json_data"
                                :labels="json_label" :csv-title="json_title">
                    <i class="fas fa-file-excel"></i>
                  </VueJsonToCsv>
                </CButtonGroup>
                <BeforeFilter :filterShow="toggleFilterValue" @getFilterToggle="switchFilter"></BeforeFilter>
              </div>
            </CCol>
          </div>
        </CCardHeader>

        <CCardBody>
          <transition name="fade">
            <CRow v-if="toggleFilterValue">
              <CCol sm="3">
                <div class="form-group">
                  <label class="form__label">{{
                      $lang.opportunity.filter.startDate
                    }}</label>
                  <input
                      type="date"
                      :placeholder="$lang.opportunity.filter.startDate"
                      class="form-control"
                      v-model="filter.startDate"
                  />
                </div>
              </CCol>
              <CCol sm="3">
                <div class="form-group">
                  <label class="form__label">{{
                      $lang.opportunity.filter.endDate
                    }}</label>
                  <input
                      type="date"
                      :placeholder="$lang.opportunity.filter.endDate"
                      class="form-control"
                      v-model="filter.endDate"
                  />
                </div>
              </CCol>
              <CCol sm="3">
                <div class="form-group">
                  <label class="form__label">{{ $lang.recruitments.filter.companyList }}</label>
                  <v-select :options="list" v-model="filter.list"></v-select>
                </div>
              </CCol>

              <CCol sm="3">
                <div class="form-group">
                  <label class="form__label">{{ $lang.recruitments.filter.experience }}</label>
                  <v-select :options="experienceList" v-model="filter.experienceList"></v-select>
                </div>
              </CCol>
              <CCol sm="3">
                <div class="form-group">
                  <label class="form__label">Our Job Opening?</label>
                  <v-select :options="ourJobList" v-model="filter.ourJob"></v-select>
                </div>
              </CCol>
              <CCol sm="3">
                <div class="form-group">
                  <label class="form__label">{{ $lang.recruitments.filter.jobType }}</label>
                  <v-select :options="jobTypeList" v-model="filter.jobTypeList"></v-select>
                </div>
              </CCol>

              <CCol sm="3">
                <div class="form-group">
                  <label class="form__label">{{ $lang.recruitments.filter.commissionType }}</label>
                  <v-select :options="commissionTypeList" v-model="filter.commissionTypeList"></v-select>
                </div>
              </CCol>

              <CCol sm="3">
                <div class="form-group">
                  <label class="form__label">{{ $lang.recruitments.filter.workType }}</label>
                  <v-select :options="workTypeList" v-model="filter.workTypeList"></v-select>
                </div>
              </CCol>

              <CCol sm="3">
                <div class="form-group">
                  <label class="form__label">{{ $lang.recruitments.filter.requirement }}</label>
                  <v-select :options="availabilityList" v-model="filter.availabilityList"></v-select>
                </div>
              </CCol>

              <CCol sm="3">
                <div class="form-group">
                  <label class="form__label">{{ $lang.recruitments.filter.currency }}</label>
                  <v-select :options="currencyList" v-model="filter.currencyList"></v-select>
                </div>
              </CCol>

              <CCol sm="3">
                <div class="form-group">
                  <label class="form__label">{{ $lang.recruitments.filter.title }}</label>
                  <input type="text" class="form-control" v-model="filter.title"/>
                </div>
              </CCol>
              <CCol sm="3">
                <div class="form-group">
                  <label class="form__label">Job Type</label>
                  <v-select
                      :options="jobTypeOptions"
                      v-model="filter.jobType"
                  ></v-select>
                </div>
              </CCol>
              <CCol sm="3">
                <div class="form-group">
                  <label class="form__label">Status</label>
                  <v-select
                      :options="statusOptions"
                      v-model="filter.status"
                  ></v-select>
                </div>
              </CCol>
              <CCol sm="3">
                <div class="form-group" style="margin-top: 30px">
                  <CButton
                      type="submit"
                      size="sm"
                      color="primary"
                      @click="applyFilter()"
                      v-c-tooltip="$lang.common.filter.button.filter"
                  >
                    {{ $lang.common.filter.button.filter }}
                  </CButton> &nbsp;
                  <CButton color="danger" size="sm" @click="resetFilter()"
                           v-c-tooltip="$lang.common.filter.button.cancel">
                    {{ $lang.common.filter.button.cancel }}
                  </CButton>
                </div>
              </CCol>
            </CRow>
          </transition>

          <CAlert color="success" closeButton :show.sync="dismissCountDownS" fade>{{ alertMessage }}</CAlert>

          <v-server-table :columns="columns" :url="listUrl" :options="options" ref="myTable"
                          @loaded="exports(self,'Excel',module,'Recruitments')">
            <template #company="data">
              <span v-if="data.row.companyName == null">{{ data.row.company }}</span>
              <span v-else>{{ data.row.companyName }}</span>
            </template>
            <template #description="data">
              <span :title="data.row.description">{{ trimfunction(data.row.description, 20) }}</span>
            </template>
            <template #minSalary="data">
              <span>{{ data.row.minSalary }}</span>
            </template>
            <template #maxSalary="data">
              <span>{{ data.row.maxSalary }}</span>
            </template>
            <template #experience="data">
              <span>{{ data.row.experience.name }}</span>
            </template>
            <template #firstName="data">
              <Avatar
                  :image="data.row.avatar"
                  :defaultImage="data.row.avatar"
                  :content="data.row.firstName"
                  :allowCompany="true"
                  :length="20"
              />
            </template>
            <template #actions="data">
              <CButton
                  color="primary"
                  v-c-tooltip="Edit"
                  v-on:click="editPopup(data.row.id)"
                  v-if='checkPermission("list-job-opening") && data.row.contactPersonEmail != null'
              >
                <i class="fas fa-pen"></i>
              </CButton>
              <CButton
                  color="danger"
                  v-c-tooltip="Publish"
                  v-on:click="publishPopup(data.row.id)"
                  v-if='checkPermission("list-job-opening") && data.row.contactPersonEmail != null'
              >
                <i class="fas fa-pen"></i>
              </CButton>
              <CButton
                  color="primary"
                  v-c-tooltip="$lang.buttons.general.crud.view"
                  v-on:click="viewJob(data.row.id,data.row.userId)"
                  v-if="checkPermission('list-job-opening')"
              >
                <i class="fas fa-eye"></i>
              </CButton>

              <CButton
                  color="primary"
                  v-c-tooltip="$lang.buttons.general.crud.candidates"
                  v-on:click="candidateList(data.row)"
                  v-if="checkPermission('list-job-opening')"
              >
                <i class="fas fa-user-friends"></i>
              </CButton>

              <CButton
                  color="danger"
                  v-c-tooltip="$lang.buttons.general.crud.delete"
                  v-on:click="deletePopup(data.row.id)"
                  v-if="checkPermission('list-job-opening')"
              >
                <i class="fas fa-trash"></i>
              </CButton>
            </template>
          </v-server-table>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import Vue from "vue";
import VueForm from "vue-form";
import store from "/src/store/store.js";
import {
  Recruitments
} from "/src/store/url.js";
import {Mixin} from "/src/mixins/index.js";
import options from "/src/validations/validations.js";
import {ServerTable} from "vue-tables-2";
import VueSweetalert2 from "vue-sweetalert2";
import BeforeFilter from "../BeforeFilterOpen";
import VueJsonToCsv from "vue-json-to-csv";
import Avatar from "/src/components/Avatar";

Vue.use(VueSweetalert2);
Vue.use(ServerTable, {}, false);
Vue.use(VueForm, options);

export default {
  name: "Recruitments",
  mixins: [Mixin],
  components: {
    BeforeFilter,
    VueJsonToCsv,
    Avatar,
  },
  data() {
    return {
      selectedColumns: [],
      iAmUser: "",
      userId: "",
      statusOptions:[],
      jobTypeOptions : [
        {
          'label' : 'Jobs',
          'value' : 'Jobs',
        },
        {
          'label' : 'B2B Jobs',
          'value' : 'B2B Jobs',
        },
        {
          'label' : 'Direct Jobs',
          'value' : 'Direct Jobs',
        },
        {
          'label' : 'Placements',
          'value' : 'Placements',
        },
        {
          'label' : 'Internships',
          'value' : 'Internships',
        }
      ],
      listUrl: "",
      list: [],
      experienceList: [],
      commissionTypeList: [],
      workTypeList: [],
      availabilityList: [],
      ourJobList: [
        {
          'label' : 'No',
          'value' : 'No',
        },{
          'label' : 'Yes',
          'value' : 'Yes',
        }
      ],
      currencyList: [],
      jobTypeList: [],
      json_data: [],
      json_label: {},
      json_title: "",
      toggleFilterValue: false,
      range: [0, 1000000],
      number: 1,
      err_msg: "",
      submitType: "",
      alertMessage: "test",
      showAlert: false,
      dismissCountDown: 0,
      dismissCountDownS: 0,
      self: this,
      jobData: [],
      requirement: [],
      worktype: [],
      activePage: 1,
      module: Recruitments,
      filter: {
        type: "",
        list: "",
        experienceList: "",
        commissionTypeList: "",
        jobTypelist: "",
        title: "",
        workTypeList: "",
        availabilityList: "",
        currencyList: "",
        ourJob: "",
        jobType: ""
      },
      recruitments: {
        registeredType: "",
        firstName: "",
        company: "",
      },
      columns: [
        "company",
        "firstName",
        // "jobType",
        "title",
        "noOfOpenings",
        // "experience",
        "minSalary",
        "maxSalary",
        // "commissionType",
        // "commissionPer",
        // "commissionMonth",
        "createdAt",
        "updatedAt",
        "actions",
      ],
      data: [],
      options: {
        headings: {
          company: this.$lang.recruitments.table.company,
          firstName: this.$lang.recruitments.table.firstName,
          // jobType: this.$lang.recruitments.table.jobtype,
          title: this.$lang.recruitments.table.title,
          noOfOpenings: this.$lang.recruitments.table.noOfOpenings,
          minSalary: this.$lang.recruitments.table.minSalary,
          maxSalary: this.$lang.recruitments.table.maxSalary,
          // experience: this.$lang.recruitments.table.experience,
          // commissionType: this.$lang.recruitments.table.commissionType,
          // commissionPer: this.$lang.recruitments.table.commission,
          // commissionMonth: this.$lang.recruitments.table.commissionMonth,
          createdAt: this.$lang.recruitments.table.added,
          updatedAt: this.$lang.recruitments.table.updated,
          actions: this.$lang.common.general.actions,
        },
        editableColumns: [],
        sortable: [
          "title",
        ],
        filterable: [],
      },
    };
  },
  created() {
    let self = this;
    this.getList('Company');
    // self.listUrl = "/job-opening/list";
    var filterDetail = JSON.parse(localStorage.getItem("Job"));
    if (filterDetail === null) {
      var filterDetail = JSON.parse(localStorage.getItem("B2BJob"));
      if (filterDetail === null) {
        var filterDetail = JSON.parse(localStorage.getItem("DirectJob"));
        if (filterDetail === null) {
          var filterDetail = JSON.parse(localStorage.getItem("Placement"));
          if (filterDetail === null) {
            var filterDetail = JSON.parse(localStorage.getItem("Internship"));
            if (filterDetail === null) {
            } else {
              self.filter.jobType = {value: "Internship", label: "Internship"};
            }
          } else {
            self.filter.jobType = {value: "Placement", label: "Placement"};
          }
        } else {
          self.filter.jobType = {value: "DirectJob", label: "DirectJob"};
        }
      } else {
        self.filter.jobType = {value: "B2BJob", label: "B2BJob"};
      }
    } else {
      self.filter.jobType = {value: "Job", label: "Job"};
    }
    if(filterDetail && filterDetail.hasOwnProperty('startDate')) {
      self.filter.startDate = filterDetail.startDate;
      self.filter.endDate = filterDetail.endDate;
      var val = "";
      if(filterDetail.status == "Open") {
        val = "1";
      }
      if(filterDetail.status == "Closed") {
        val = "2";
      }
      if(filterDetail.status == "New") {
        val = "4";
      }
      if(val != "") {
        self.filter.status = {value: val, label: filterDetail.status};
      }
      self.listUrl = "/job-opening/list?jobType="+self.filter.jobType.value+"&fromDate="+filterDetail.startDate+"&toDate="+filterDetail.endDate;
      // self.applyFilter();
      localStorage.setItem("Job",null);
      localStorage.setItem("B2BJob",null);
      localStorage.setItem("DirectJob",null);
      localStorage.setItem("Placement",null);
      localStorage.setItem("Internship",null);
    } else {
      self.listUrl = "/job-opening/list";
    }
  },
  mounted() {
    let self = this;
    self.dismissCountDown = 0;
    self.dismissCountDownS = 0;
    store.commit("showLoader", false);
    self.userId = this.$route.params.user_id;
    if (typeof self.userId !== "undefined" || self.userId != null) {
      self.listUrl = this.listUrl + self.userId;
    } else {
      self.listUrl = this.listUrl;
    }
    self.statusOptions.push(
        {value: "1", label: "Open"},
        {value: "2", label: "Closed"},
        {value: "4", label: "New"}
    );
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page);
        }
      },
    },
  },
  methods: {
    createTableRow() {
      this.$router.push({name: 'Recruitment Create'})
    },
    getList(type) {
      let self = this;
      self.userList = "/job-opening/list";
      axios.get(self.userList)
          .then((response) => {
            let responseData = response.data;
            responseData.data.map(function (value, key) {
              if (type === 'Company') {
                self.list.push({ value: value.companyId, label: value.company });
              }
              if (value.experience !== null) {
                self.experienceList.push({ value: value.experience.id, label: value.experience.name });
              }
              if (value.worktype !== null) {
                self.workTypeList.push({ value: value.worktype.id, label: value.worktype.title });
              }
              if (value.availability !== null) {
                self.availabilityList.push({ value: value.availability.id, label: value.availability.name });
              }
              self.commissionTypeList.push({value: value.commissionType, label: value.commissionType});
              self.jobTypeList.push({value: value.jobTypeShortName, label: value.jobType});
              self.currencyList.push({value: value.currency.id, label: value.currency.currencySymbol});
            });
            self.list = this.removeDuplicateValues(self.list);
            self.experienceList = this.removeDuplicateValues(self.experienceList);
            self.commissionTypeList = this.removeDuplicateValues(self.commissionTypeList);
            self.jobTypeList = this.removeDuplicateValues(self.jobTypeList);
            self.workTypeList = this.removeDuplicateValues(self.workTypeList);
            self.availabilityList = this.removeDuplicateValues(self.availabilityList);
            self.currencyList = this.removeDuplicateValues(self.currencyList);
          });
    },
    /* get from child component */
    switchFilter(show) {
      this.toggleFilterValue = show;
    },
    applyFilter() {
      let self = this;
      let reqObj = {
        registeredType: 'Company',
        id: self.filter.list?.value,
        experienceId: self.filter.experienceList?.value,
        commissionType: self.filter.commissionTypeList?.value,
        jobType: self.filter.jobTypeList?.value,
        workType: self.filter.workTypeList?.value,
        availability: self.filter.availabilityList?.value,
        currency: self.filter.currencyList?.value,
        ourJob: self.filter.ourJob?.value,
        title: (self.filter.title) ? self.filter.title : null,
        status: self.filter.status?.value,
        fromDate: self.filter.startDate,
        toDate: self.filter.endDate,
      };
      store.commit("showLoader", true); // Loader Start
      self.listUrl = "/job-opening/list";
      this.$refs.myTable.customQueries = reqObj;
      this.$refs.myTable.refresh();
    },
    resetFilter() {
      let self = this;
      self.filter.title = null;
      self.filter.list = [];
      self.filter.experienceList = [];
      self.filter.commissionTypeList = [];
      self.filter.jobTypeList = [];
      self.filter.workTypeList = [];
      self.filter.availabilityList = [];
      self.filter.currencyList = [];
      self.filter.ourJob = [];
      self.filter.endDate = {};
      self.filter.startDate = {};
      self.filter.status = {};
      store.commit("showLoader", true); // Loader Start
      self.listUrl = "/job-opening/list";
      this.$refs.myTable.customQueries = {};
      this.$refs.myTable.refresh();
    },
    setAlert(value) {
      this.showAlert = value;
    },
    deletePopup(item) {
      this.$swal({
        title: this.$lang.common.delete_swal.are_you,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#e55353",
        confirmButtonText: this.$lang.common.delete_swal.yes_delete,
        cancelButtonText: this.$lang.common.delete_swal.cancel,
      }).then((result) => {
        if (result.value) {
          let self = this;
          axios.delete(this.deleteUrlWeb(this.module, item), self)
              .then(function (response) {
                if (response.status === 200) {
                  self.$refs.myTable.refresh();
                  self.alertMessage = response.data.response.message;
                  self.dismissCountDownS = 10;
                }
              });
        }
      });
    },
    viewJob(id, userId) {
      this.$router.push({path: `job-openings/view/${id}/${userId}`});
    },
    editPopup(id) {
      this.$router.push({path: `job-openings/edit/${id}`});
    },
    publishPopup(id) {
      this.$router.push({path: `job-openings/publish/${id}`});
    },
    candidateList(row) {
      this.$router.push({path: `/job-openings/candidates/${row.id}`});
    },

    pageChange(val) {
      this.$router.push({query: {page: val}});
    },
  },
};
</script>
